const COMPANY_INFORMATION = { code: "CI", description: "Company Information", systemName: "vobInformation", shortDescription: "Company", tabKey: "companyInfo" };
const VETERAN_INFORMATION = { code: "VI", description: "Veteran Information", systemName: "veteranInformation", shortDescription: "Veterans", tabKey: "veteranOwnerInfo" };
const BUSINESS_STRUCTURE = { code: "BS", description: "Business Structure", systemName: "businessStructure", shortDescription: "Business Struc.", tabKey: "businessStructure" };
const CERTIFICATIONS = { code: "CER", description: "Certifications", systemName: "certification", shortDescription: "Certifications", tabKey: "businessCertification" };
const FINANCES = { code: "FIN", description: "Finances", systemName: "finances", shortDescription: "Finances", tabKey: "financialDocuments" };
const BANKING = { code: "BNK", description: "Banking", systemName: "banking", shortDescription: "Banking", tabKey: "bankInfo" };
const TAXES = { code: "TAX", description: "Taxes", systemName: "taxes", shortDescription: "Taxes", tabKey: "taxInfo" };
const EQUIPMENT = { code: "EQ", description: "Equipment", systemName: "equipment", shortDescription: "Equipment", tabKey: "equipmentInfo" };
const ARTICLES = { code: "ART", description: "Articles", systemName: "articles", shortDescription: "Articles", tabKey: "articles" };
const DECLARATION = { code: "DEC", description: "Declaration", systemName: "declaration", shortDescription: "Declaration", tabKey: "declaration" };

//Site Review
const SITE_INFORMATION = { code: "SIN", description: "Site Information", systemName: "siteInformation", tabKey: "siteInfo", queueTypeCode: "STR" };
const CORPORATE_ID = { code: "COR", description: "Corporate ID", systemName: "corporateId", tabKey: "corporateId", queueTypeCode: "STR" };
const CORPORATE_OWNERS = { code: "COW", description: "Corporate Owners/Contacts", systemName: "corporateOwners", tabKey: "corporateOwners", queueTypeCode: "STR" };
const COMPANY_HISTORY = { code: "SCH", description: "Company History", systemName: "businessHistory", tabKey: "companyHistory", queueTypeCode: "STR" };
const CAPITAL_CONTRIBUTION = { code: "CC", description: "Capital Contributions/Expertise", systemName: "capitalContributions", tabKey: "capitalContribution", queueTypeCode: "STR" };
const OPERATION_CONTROL = { code: "SOC", description: "Operation & Control", systemName: "operationAndControl", tabKey: "operationAndControl", queueTypeCode: "STR" };
const EMPLOYEE_COMP = { code: "SEC", description: "Employee Compensation", systemName: "employeeCompensation", tabKey: "employeeAndComp", queueTypeCode: "STR" };
const TOUR = { code: "STF", description: "Tour", systemName: "tour", tabKey: "tour", queueTypeCode: "STR" };

const REVIEW_TYPES = [
    COMPANY_INFORMATION,
    VETERAN_INFORMATION,
    BUSINESS_STRUCTURE,
    CERTIFICATIONS,
    FINANCES,
    BANKING,
    TAXES,
    EQUIPMENT,
    ARTICLES];

//Review Types
const APPLICATION_REVIEW = { code: "APR", description: "Application Review", tabKey: "appReview", abbreviation: "App Review", queueTypeCode: "APP", };
const CERTIFICATION_REVIEW = { code: "CTR", description: "Certification Review", tabKey: "certReview", abbreviation: "Cert Review", queueTypeCode: "CER", };
const SITE_REVIEW = { code: "STR", description: "Site Review", tabKey: "finalRecomm", abbreviation: "Final Recommendation", queueTypeCode: "STR", };
const COMMITTEE_REVIEW = { code: "CMR", description: "Committee Review", tabKey: "comReview", abbreviation: "Comm Review", queueTypeCode: "COM", };
const FINAL_REVIEW = { code: "FNR", description: "Final Review", tabKey: "finalReview", abbreviation: "Final Review", queueTypeCode: "FIN", };

const REVIEW_QUEUES = [
    APPLICATION_REVIEW,
    CERTIFICATION_REVIEW,
    SITE_REVIEW,
    FINAL_REVIEW,
    COMMITTEE_REVIEW
];

const ASSIGN_TAB = { code: "ASSIGN", description: "Assign", tabKey: "assign", abbreviation: "Assign" };

const CERT_TABS = [
    COMPANY_INFORMATION,
    VETERAN_INFORMATION,
    BUSINESS_STRUCTURE,
    CERTIFICATIONS,
    FINANCES,
    BANKING,
    TAXES,
    EQUIPMENT,
    ARTICLES,
    DECLARATION,
    EMPLOYEE_COMP,
    TOUR,
    SITE_INFORMATION,
    CAPITAL_CONTRIBUTION,
    COMPANY_HISTORY,
    OPERATION_CONTROL,
    CORPORATE_OWNERS,
    CORPORATE_ID,
    APPLICATION_REVIEW,
    CERTIFICATION_REVIEW,
    SITE_REVIEW,
    FINAL_REVIEW,
    COMMITTEE_REVIEW,
    ASSIGN_TAB
];

export default {
    REVIEW_TYPES,
    COMPANY_INFORMATION,
    VETERAN_INFORMATION,
    BUSINESS_STRUCTURE,
    CERTIFICATIONS,
    FINANCES,
    BANKING,
    TAXES,
    EQUIPMENT,
    ARTICLES,
    DECLARATION,
    EMPLOYEE_COMP,
    TOUR,
    SITE_INFORMATION,
    CAPITAL_CONTRIBUTION,
    COMPANY_HISTORY,
    OPERATION_CONTROL,
    CORPORATE_OWNERS,
    CORPORATE_ID,
    APPLICATION_REVIEW,
    CERTIFICATION_REVIEW,
    SITE_REVIEW,
    FINAL_REVIEW,
    COMMITTEE_REVIEW,
    CERT_TABS,
    REVIEW_QUEUES
};


// WEBPACK FOOTER //
// ./src/areas/shared/consts/ReviewType.js